<template>
  <div class="view-clients">
    <h4 class="text-semibold mb-4">Clientes</h4>
    <snow-data-table-header
      :add="false"
      :datePicker="false"
      :exportOptions="exportOptions"
      @open-filters="filtersModal = true"
      @searching="search"
    />

    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <snow-data-table v-else :data="reports" :columns="columns">
      <template #no-content-actions>
        <div class="d-flex flex-column gap-4">
          <div class="bg-2 rounded-16 p-4 d-flex gap-3">
            <i class="ph ph-rocket-launch fs-32" />
            <div class="d-flex flex-column gap-1">
              <h6 class="text-semibold">Criar um novo produto</h6>
              <h6 class="text-dark-40">
                Se não tiver criado nenhum, va em novo produto e comece a criar
                o seu.
              </h6>
            </div>
          </div>
          <div class="bg-2 rounded-16 p-4 d-flex gap-3">
            <i class="ph ph-clock fs-32" />
            <div class="d-flex flex-column gap-1">
              <h6 class="text-semibold">Esperar por vendas</h6>
              <h6 class="text-dark-40">
                Se seu produto já publicado, não vai demorar em aparecer vendas.
              </h6>
            </div>
          </div>
        </div>
      </template>
    </snow-data-table>

    <div
      v-if="reports.length && !loading"
      class="d-flex justify-content-end mt-4"
    >
      <snow-paginator
        v-model="page"
        :pagination="pagination"
        @change-page="onPaginationUpdate"
      />
    </div>

    <responsive-modal v-model="detailDialog" title="Dados do cliente">
      <client-details :client="detailedItem" @close="detailDialog = false" />
    </responsive-modal>

    <responsive-modal
      v-model="filtersModal"
      title="Filtrar"
      description="Selecione os filtros e aplique"
    >
      <clients-filter
        v-model="filters"
        @close="filtersModal = false"
        @input="() => dispatch()"
      />
    </responsive-modal>
  </div>
</template>

<script>
import ClientDetails from "@/components/reports/ClientDetails";
import ClientsFilter from "@/components/reports/ClientsFilter";
import { mapState } from "vuex";
import { toHumanDate } from "@/functions/helpers";

export default {
  components: { ClientsFilter, ClientDetails },
  data() {
    return {
      loading: false,
      detailedItem: null,
      detailDialog: false,
      filtersModal: false,
      page: 1,
      filters: {
        finished_order: "",
        product_id: "",
        offer_id: "",
        plan_id: "",
        sck: ""
      },
      params: {
        search: "",
        limit: 20,
        offset: 0
      }
    };
  },
  mounted() {
    this.dispatch();
    this.$store.dispatch("product/get", { limit: 1000 }).then();
  },
  computed: {
    ...mapState("reports", ["reports", "pagination"]),
    ...mapState("product", ["products"]),
    isExportDisabled() {
      return !this.reports.length;
    },
    exportOptions() {
      return {
        action: "reports/getShoppers",
        filters: () => this.filters,
        filename: "clients_report",
        disabled: this.isExportDisabled,
        label: "Exportar",
        permission: "exportar-vendas"
      };
    },
    columns() {
      return [
        {
          name: "ID",
          field: "id"
        },
        {
          name: "Comprador",
          field: "name"
        },
        {
          name: "Produto",
          field: "product",
          transform: product => (product ? product.name : "")
        },
        {
          name: "Data da compra",
          field: "finished_order",
          transform: v =>
            v ? toHumanDate(v).replace(/(\d{2}:\d{2})/, "às $1") : "-"
        },
        {
          name: "Status de compra",
          field: "finished_order",
          transform: v => (v ? "Realizada" : "Incompleta"),
          class: v => (v ? "active-badge" : "incomplete-badge")
        },
        {
          type: "menu",
          options: this.actions
        }
      ];
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.dispatch();
      }
    }
  },
  methods: {
    refresh() {
      this.params.search = "";
      this.dispatch();
    },
    search(text) {
      this.params.search = text;
      this.dispatch();
    },
    catchHandler(error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.details
      ) {
        this.$message.error(error.response.data.details);
      }
    },
    onPaginationUpdate(offset) {
      this.params.offset = offset;
      this.dispatch();
    },
    dispatch() {
      const params = {
        ...this.filters,
        ...this.params
      };
      this.loading = true;
      this.$store
        .dispatch("reports/getShoppers", params)
        .then()
        .catch(this.catchHandler)
        .finally(() => {
          this.loading = false;
        });
    },
    detail(item) {
      this.detailDialog = true;
      this.detailedItem = item;
    },
    actions() {
      const actions = [
        {
          label: "Detalhes",
          click: this.detail
        }
      ];
      return actions;
    }
  }
};
</script>
